/* Copyright 2021, Milkdown by Mirone. */
import { timerNotFound } from '@milkdown/exception';
export const createClock = () => {
    const store = new Map();
    const get = (timer) => {
        const meta = store.get(timer.id);
        if (!meta)
            throw timerNotFound();
        return meta;
    };
    return {
        store,
        get,
    };
};
//# sourceMappingURL=clock.js.map